// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"NavigationButtons_buttonsContainer__2ooCX"};